import { openModals } from '../modal.ts';
import { canHover } from './breakpoints.ts';

function hasModifierKey(event: MouseEvent | KeyboardEvent): boolean {
    return event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

/**
 * Whether a press is a finger's, or a stylus tip's on a touch screen.
 *
 * There a stylus taps and holds like a finger. Where the main pointer can
 * hover, as on a desktop, a pen stands in for a mouse. A pen's barrel and
 * eraser buttons don't tap.
 */
export function isTouchPress(event: PointerEvent): boolean {
    if (event.pointerType === 'touch') return true;
    return event.pointerType === 'pen' && event.button === 0 && !canHover();
}

export function shouldOpenInNewTab(e: MouseEvent): boolean {
    return hasModifierKey(e) || (e.button !== undefined && e.button !== 0);
}

export function shouldNavigateWithArrowKey(event: KeyboardEvent): boolean {
    const target = event.target;

    return (
        !hasModifierKey(event) &&
        !isLightboxOpen() &&
        !(target instanceof Element && target.closest('input, textarea, select, [contenteditable]'))
    );
}

export function isLightboxOpen(): boolean {
    return !!document.querySelector('.pswp') || openModals > 0;
}
